<div class="panel-header" *ngIf="usuario?.rol !== 'estudiante' && !mostrarChat">
  <button
    class="tab-button"
    [class.active]="mostrarDocumentos"
    (click)="togglePanel('documentos')"
  >
    <i class="fas fa-file-alt"></i> Documentos
  </button>
  <button
    class="tab-button"
    [class.active]="mostrarEntregas"
    (click)="togglePanel('entregas')"
  >
    <i class="fas fa-brain"></i> Trabajos de alumnos
  </button>
</div>
<div class="contenedor">
  <!-- Panel Documentos -->
  <div
    class="documentos"
    *ngIf="mostrarDocumentos && !mostrarChat && usuario?.rol !== 'estudiante'"
  >
    <section class="basicbox">
      <h2 class="panel-title">📚 Documentos</h2>
      <div class="contenedordocumentos">
        <div class="documento" *ngFor="let documento of documentos">
          <div class="col-nombre">
            <div class="col-nombre" (click)="abrirDocumento(documento)">
              <i [class]="getIconClass(documento) + ' doc-icon'"></i>
              <p class="nombre">{{ documento.nombre }}</p>
            </div>
            <div class="col-switch" *ngIf="usuario?.rol !== 'estudiante'">
              <label class="switch">
                <input
                  type="checkbox"
                  [(ngModel)]="documento.activado"
                  (change)="actualizarEstado(documento)"
                />
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="col-borrar" *ngIf="usuario?.rol !== 'estudiante'">
            <button (click)="deleteDocumento(documento)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="bottom-fixed">
        <div class="botones-container">
          <input
            type="file"
            id="localFile"
            hidden
            #localFileInput
            (change)="uploadLocalFiles($event)"
            multiple
            accept=".pdf, .docx, .txt, .pptx"
          />
          <button
            *ngIf="usuario?.rol !== 'estudiante'"
            (click)="localFileInput.click()"
          >
            <i class="fa fa-upload"></i>
          </button>
        </div>
        <div class="upload-progress" *ngIf="porcentaje !== null">
          <progress [value]="porcentaje" max="100"></progress>
          <span>{{ porcentaje }}%</span>
        </div>
      </div>
    </section>
  </div>

  <!-- Panel Entregas -->
  <div
    class="documentos"
    *ngIf="mostrarEntregas && usuario?.rol !== 'estudiante' && !mostrarChat"
  >
    <section class="basicbox">
      <h2 class="panel-title">📄 Trabajos de alumnos</h2>
      <div class="contenedordocumentos">
        <div class="documento" *ngFor="let entrega of entregas">
          <div>
            <div class="col-nombre2" (click)="abrirDocumento(entrega)">
              <div class="col-nombre2">
                <span class="nombre">{{ entrega.nombre }} </span>
                <div *ngIf="entrega.procesado" class="veredicto-detalles">
                  <p>🤖 IA:</p>
                  <div class="barra-con-porcentaje">
                    <p class="porcentaje-texto">
                      {{ entrega.sospechaIA * 100 | number : "1.0-0" }}%
                    </p>
                    <div class="barra-porcentaje">
                      <div
                        class="progreso"
                        [ngStyle]="{
                          width: entrega.sospechaIA * 100 + '%',
                          backgroundColor: getColorIA(entrega.sospechaIA)
                        }"
                      ></div>
                    </div>
                  </div>

                  <p>📑 Plagio:</p>
                  <div class="barra-con-porcentaje">
                    <p class="porcentaje-texto">
                      {{ entrega.sospechaPlagio * 100 | number : "1.0-0" }}%
                    </p>
                    <div class="barra-porcentaje">
                      <div
                        class="progreso"
                        [ngStyle]="{
                          width: entrega.sospechaPlagio * 100 + '%',
                          backgroundColor: getColorIA(entrega.sospechaPlagio)
                        }"
                      ></div>
                    </div>
                  </div>

                  <p>🧠 Redacción humana:</p>
                  <div class="barra-con-porcentaje">
                    <p class="porcentaje-texto">
                      {{ entrega.redaccionHumana * 100 | number : "1.0-0" }}%
                    </p>
                    <div class="barra-porcentaje">
                      <div
                        class="progreso"
                        [ngStyle]="{
                          width: entrega.redaccionHumana * 100 + '%',
                          backgroundColor: getColorHumana(
                            entrega.redaccionHumana
                          )
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="!entrega.procesado"
                  style="margin-top: 6px; font-size: 0.8rem; color: #999"
                >
                  ⏳ Analizando...
                </div>
              </div>
            </div>
          </div>
          <div class="col-borrar" *ngIf="usuario?.rol !== 'estudiante'">
            <button (click)="deleteEntrega(entrega)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="bottom-fixed">
        <div class="botones-container">
          <input
            type="file"
            id="studentFile"
            hidden
            #studentFileInput
            (change)="uploadStudentWork($event)"
            accept=".pdf, .docx, .txt"
          />
          <button (click)="studentFileInput.click()">
            <i class="fas fa-brain"></i>
          </button>
        </div>
        <div class="upload-progress" *ngIf="porcentaje !== null">
          <progress [value]="porcentaje" max="100"></progress>
          <span>{{ porcentaje }}%</span>
        </div>
      </div>
    </section>
  </div>

  <!-- Popup para crear un nuevo chat si no existen chats -->
  <div class="nuevo-chat-info" *ngIf="!hasAnyChatSessions()">
    <h2>¡Bienvenido!</h2>
    <p>
      No tienes ningún chat activo.<br />Haz clic en el botón para crear uno
      nuevo.
    </p>
    <button (click)="newChat()">Crear nuevo chat</button>
  </div>
  <!-- Panel de Chat -->
  <div
    *ngIf="hasAnyChatSessions()"
    class="userchat"
    [class.fullscreen]="mostrarChat"
  >
    <!-- Panel de bienvenida -->
    <section class="basicbox chatmessages">
      <h2 class="panel-title">🤓 Mentix</h2>

      <!-- Contenedor de mensajes; se usa "
         gesbox" para hacer scroll -->
      <div class="messages" id="themessagesbox" [scrollTop]="scrolltobottom()">
        <div *ngIf="showWelcomePanel" class="welcome-panel">
          <h2>{{ welcomeMessage }}</h2>
          <p>{{ asistentePerfil.descripcion }}</p>

          <div class="quick-suggestions">
            <h4>¿Sobre qué quieres trabajar?</h4>
            <div class="buttons-suggestions">
              <button
                *ngFor="let sugerencia of quickSuggestions"
                (click)="chatmessage = sugerencia"
                (click)="sendMessage()"
              >
                {{ sugerencia }}
              </button>
            </div>
          </div>
        </div>
        <!-- Mensajes enviados -->
        <ng-container *ngFor="let message of chatIa">
          <div
            [ngClass]="{
              'message-right': message?.payload.doc.data().sender === 'openai',
              'message-left': message?.payload.doc.data().sender === mainuserid
            }"
          >
            <!-- Mensaje del usuario -->
            <div
              class="sender"
              *ngIf="message?.payload.doc.data().sender === mainuserid"
            >
              <div class="messagedata-usuario">
                <div class="cabecera">
                  <div class="date-usuario">
                    {{
                      message?.payload.doc.data().fecha.toDate()
                        | date : "dd/MM/y - HH:mm"
                    }}h
                  </div>
                  <div class="name-usuario">
                    {{ usuario?.nombres }} {{ usuario?.apellidos }}
                  </div>
                </div>
                <div class="themessage-usuario">
                  <p>{{ message?.payload.doc.data().message }}</p>
                </div>
              </div>
              <div class="avatar">
                <img
                  *ngIf="usuario?.avatar; else defaultavatar"
                  [src]="usuario?.avatar"
                  alt="Avatar Usuario"
                />
                <ng-template #defaultavatar>
                  <img
                    src="assets/img/defaultavatar.jpg"
                    alt="Avatar por defecto"
                  />
                </ng-template>
              </div>
            </div>
            <!-- Mensaje del asistente -->
            <div
              class="sender"
              *ngIf="message?.payload.doc.data().sender === 'openai'"
            >
              <div class="avatar">
                <img src="assets/img/Botito.png" alt="Avatar por defecto" />
              </div>
              <div class="messagedata-asistente">
                <div class="cabecera">
                  <div class="name-asistente">Mentix&nbsp;</div>
                  <div class="date-asistente">
                    {{
                      message?.payload.doc.data().fecha.toDate()
                        | date : "dd/MM/y - HH:mm"
                    }}h
                  </div>
                </div>
                <div class="themessage-asistente">
                  <!-- Se muestra el mensaje procesado -->
                  <div [innerHTML]="message?.processedMessage"></div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- Mensaje en proceso (efecto tipeo) -->
        <div *ngIf="loadingResponse" class="message-right">
          <div class="avatar">
            <img src="assets/img/ROBOTTHECAMPUS.png" alt="Avatar por defecto" />
          </div>
          <div class="messagedata">
            <div class="cabecera">
              <div class="name-asistente">Asistente&nbsp;</div>
              <div class="date-asistente">Ahora</div>
            </div>
            <!-- Spinner de respuesta -->
            <div *ngIf="loadingResponse" class="loading-spinner">
              <i class="fas fa-spinner fa-spin"></i> Procesando respuesta...
            </div>

            <div *ngIf="typingMessage != ''" class="themessage-asistente">
              <div [innerHTML]="formattedTypingMessage"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Caja de envío de mensaje -->
      <div class="sendbox">
        <div class="input-with-button">
          <input
            class="messagebox"
            type="text"
            placeholder="Pregutame lo que quieras"
            [(ngModel)]="chatmessage"
            (keyup.enter)="sendMessage()"
          />
          <button
            class="send-button"
            (click)="sendMessage()"
            [disabled]="isLoading"
          >
            <ng-container *ngIf="!isLoading; else loadingIcon">
              <i class="fas fa-paper-plane"></i>
            </ng-container>
            <ng-template #loadingIcon>
              <i class="fas fa-spinner fa-spin"></i>
              <!-- Ícono girando -->
            </ng-template>
          </button>
        </div>
      </div>
    </section>
  </div>

  <!-- Panel de Ventanas (Ampliar/Volver, Nuevo Chat, Historial) -->
  <div class="ventanas">
    <section class="basicbox ventanasbox">
      <button
        *ngIf="usuario.rol != 'estudiante'"
        (click)="toggleView()"
        class="buttonExpandir"
      >
        {{ mostrarChat ? "Volver" : "Ampliar" }}
      </button>
      <button (click)="newChat()" class="buttonNuevoChat">Nuevo Chat</button>
      <div class="chat-groups">
        <div *ngIf="groupedChatSessions.today?.length > 0">
          <h3 class="daychat">Hoy</h3>
          <div
            *ngFor="let chat of groupedChatSessions.today"
            class="chat-title"
            (click)="openChatSession(chat)"
          >
            {{ chat.title }}
            <button
              (click)="deleteChat(chat.id)"
              class="delete-chat-button"
              title="Borrar chat"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div *ngIf="groupedChatSessions.yesterday?.length > 0">
          <h3 class="daychat">Ayer</h3>
          <div
            *ngFor="let chat of groupedChatSessions.yesterday"
            class="chat-title"
            (click)="openChatSession(chat)"
          >
            <p>
              {{ chat.title }}
            </p>
            <button
              (click)="deleteChat(chat.id)"
              class="delete-chat-button"
              title="Borrar chat"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div *ngIf="groupedChatSessions.last7Days?.length > 0">
          <h3 class="daychat">7 días anteriores</h3>
          <div
            *ngFor="let chat of groupedChatSessions.last7Days"
            class="chat-title"
            (click)="openChatSession(chat)"
          >
            <p>
              {{ chat.title }}
            </p>
            <button
              (click)="deleteChat(chat.id)"
              class="delete-chat-button"
              title="Borrar chat"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div *ngIf="groupedChatSessions.older?.length > 0">
          <h3 class="daychat">Más antiguos</h3>
          <div
            *ngFor="let chat of groupedChatSessions.older"
            class="chat-title"
            (click)="openChatSession(chat)"
          >
            <p>
              {{ chat.title }}
            </p>
            <button
              (click)="deleteChat(chat.id)"
              class="delete-chat-button"
              title="Borrar chat"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
